module.exports = __webpack_public_path__ + "img/ico-user-deactive.70eb804a.svg";